module.exports = __webpack_public_path__ + "img/brand.61f77c5e.svg";